/**
 * @fileoverview
 * Audit Info Card Component - Display audit information
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-audit-info-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './audit-info-card.component.html',
  styleUrl: './audit-info-card.component.css',
})
export class AuditInfoCardComponent {
  @Input() auditType: string | null | undefined = null;
  @Input() region: string | null | undefined = null;
  @Input() branch: string | null | undefined = null;
  @Input() date: string | null | undefined = null;
  @Input() time: string | null | undefined = null;
  @Input() fromDate: string | null | undefined = null;
  @Input() toDate: string | null | undefined = null;
  @Input() showRegion: boolean = true;
  @Input() showBranch: boolean = true;
  @Input() showDateTime: boolean = false; // Only show date/time for asset management module
  /** Optional: override label styling (e.g. "text-sm text-gray-500" for larger text in score card). */
  @Input() labelClass: string = 'text-xs text-gray-500';
  /** Optional: override value styling (e.g. "text-sm font-semibold text-gray-900"). */
  @Input() valueClass: string = 'text-xs font-medium text-gray-900 break-words';
}

